import orderBy from 'lodash/orderBy';

import { DeploymentStatus } from '@/graphql';

import {
  ChainDeploymentFragment,
  ChainletFragment,
  ChainletMetaFragment,
} from './__generated__/fragments.generated';

function getActiveChainletsCount(deployment: ChainDeploymentFragment): [number, number] {
  const allChainletsCount = deployment.chainlets.length;
  const activeChainletsCount = deployment.chainlets.filter(
    (chainlet) =>
      chainlet.oracleVersion.currentModelDeploymentStatus.status === DeploymentStatus.ModelReady,
  ).length;

  return [activeChainletsCount, allChainletsCount];
}

function getInstanceTypeDisplayName(name: string = ''): string {
  return name.split('-')[1].trim();
}

function getEntrypointChainlet(
  deployment: ChainDeploymentFragment,
): ChainletFragment | ChainletMetaFragment | undefined {
  return deployment?.chainlets.find((chainlet) => chainlet.isEntrypoint);
}

function getOrderedChainlets(chainlets: ChainletFragment[]): ChainletFragment[] {
  return orderBy(
    chainlets,
    // move entrypoint chainlet to the top
    (chainlet) => (chainlet.isEntrypoint ? 0 : 1),
    ['asc'],
  );
}

export {
  getActiveChainletsCount,
  getInstanceTypeDisplayName,
  getEntrypointChainlet,
  getOrderedChainlets,
};
